var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.showModal, "max-width": "720", scrollable: "" },
      on: { input: _vm.onShowChange },
    },
    [
      _c(
        "v-snackbar",
        {
          attrs: {
            color: _vm.feedback.color,
            timeout: _vm.feedback.color === "error" ? 6000 : 3500,
            top: "",
            right: "",
          },
          model: {
            value: _vm.feedback.show,
            callback: function ($$v) {
              _vm.$set(_vm.feedback, "show", $$v)
            },
            expression: "feedback.show",
          },
        },
        [
          _c("v-icon", { attrs: { left: "", dark: "" } }, [
            _vm._v(
              _vm._s(
                _vm.feedback.color === "error"
                  ? "mdi-alert-circle"
                  : "mdi-check-circle"
              )
            ),
          ]),
          _vm._v(" " + _vm._s(_vm.feedback.message) + " "),
        ],
        1
      ),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "d-flex align-center" },
            [
              _c("v-icon", { attrs: { left: "", color: "indigo darken-2" } }, [
                _vm._v("mdi-auto-fix"),
              ]),
              _vm._v(" Sugestões de Substituição "),
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { icon: "" }, on: { click: _vm.cancel } },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-text",
            { staticClass: "pt-4", staticStyle: { "max-height": "70vh" } },
            [
              _c(
                "v-card",
                { staticClass: "mb-3 pa-3", attrs: { outlined: "" } },
                [
                  _c("div", { staticClass: "caption grey--text" }, [
                    _vm._v("Sala atual"),
                  ]),
                  _c("div", { staticClass: "subtitle-1 font-weight-medium" }, [
                    _vm._v(" " + _vm._s(_vm.sourceLabel) + " "),
                  ]),
                  _vm.result.source
                    ? _c("div", { staticClass: "body-2 grey--text" }, [
                        _vm.sourceClassLabel
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "font-weight-medium grey--text text--darken-2",
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-1",
                                    attrs: { "x-small": "" },
                                  },
                                  [_vm._v("mdi-school-outline")]
                                ),
                                _vm._v(
                                  " Turma: " +
                                    _vm._s(_vm.sourceClassLabel) +
                                    " "
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.result.source.headcount) +
                              " alunos "
                          ),
                          _vm.result.source.day_name
                            ? _c("span", [
                                _vm._v(
                                  " · " + _vm._s(_vm.result.source.day_name)
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(
                            " · " +
                              _vm._s(
                                _vm.formatTime(_vm.result.source.hour_start)
                              ) +
                              " – " +
                              _vm._s(
                                _vm.formatTime(_vm.result.source.hour_end)
                              ) +
                              " "
                          ),
                        ]),
                        _vm.result.source.headcount === 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "orange--text text--darken-2 text-caption mt-1",
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      "x-small": "",
                                      color: "orange darken-2",
                                    },
                                  },
                                  [_vm._v("mdi-alert-outline")]
                                ),
                                _vm._v(
                                  " Esta turma não tem alunos lançados — substituí-la não reduz a ocupação da sala. "
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]
              ),
              _vm.isConsolidatedBlock
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mb-3 block-warning",
                      attrs: {
                        type: "info",
                        dense: "",
                        text: "",
                        icon: "mdi-link-variant",
                      },
                    },
                    [
                      _c("strong", [
                        _vm._v(
                          "Esta alteração afetará o bloco completo de " +
                            _vm._s(_vm.blockDurationLabel) +
                            " minutos desta disciplina"
                        ),
                      ]),
                      _c("span", { staticClass: "d-block text-caption" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.classScheduleIds.length) +
                            " tempos de aula sequenciais serão movidos juntos para a nova sala. Operação atômica — todos os tempos mudam ou nenhum muda. "
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _c("emc-loader-progress", { attrs: { show: _vm.loading } }),
              _vm.loadError
                ? _c(
                    "v-alert",
                    { attrs: { type: "error", dense: "", text: "" } },
                    [
                      _vm._v(
                        " Não foi possível carregar as sugestões. Tente novamente. "
                      ),
                    ]
                  )
                : !_vm.loading && _vm.noResults
                ? _c(
                    "div",
                    [
                      _c(
                        "v-alert",
                        {
                          staticClass: "mb-3",
                          attrs: { type: "warning", dense: "", text: "" },
                        },
                        [
                          _c("strong", [_vm._v("Sem opções de substituição.")]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.messages ||
                                  "Nenhuma sala disponível atende ao perfil desta turma."
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "v-card",
                        {
                          staticClass: "pa-3 mb-3 reconsider-card",
                          attrs: { outlined: "" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-start" },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-2 mt-1",
                                  attrs: { color: "indigo darken-2" },
                                },
                                [_vm._v("mdi-lightbulb-on-outline")]
                              ),
                              _c(
                                "div",
                                { staticClass: "flex-grow-1" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "subtitle-2 font-weight-medium mb-1",
                                    },
                                    [_vm._v(" Repensar a oferta ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-caption grey--text text--darken-1 mb-2",
                                    },
                                    [
                                      _vm._v(
                                        " Sem sala compatível, registre uma solicitação para revisar a oferta desta turma (ex.: dividir em duas, mudar horário, reduzir matrículas). Sua solicitação é auditada com usuário, data, hora e IP. "
                                      ),
                                    ]
                                  ),
                                  _c("v-textarea", {
                                    staticClass: "mb-2",
                                    attrs: {
                                      label: "Justificativa (opcional)",
                                      rows: "2",
                                      outlined: "",
                                      dense: "",
                                      counter: "1000",
                                      rules: [
                                        (v) =>
                                          !v ||
                                          v.length <= 1000 ||
                                          "Máximo 1000 caracteres.",
                                      ],
                                    },
                                    model: {
                                      value: _vm.reconsiderNote,
                                      callback: function ($$v) {
                                        _vm.reconsiderNote = $$v
                                      },
                                      expression: "reconsiderNote",
                                    },
                                  }),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        small: "",
                                        color: "indigo darken-2",
                                        dark: "",
                                        loading: _vm.reconsidering,
                                        disabled:
                                          _vm.reconsidering ||
                                          _vm.reconsiderDone,
                                      },
                                      on: { click: _vm.requestReconsider },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { left: "", small: "" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.reconsiderDone
                                                ? "mdi-check"
                                                : "mdi-send-outline"
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.reconsiderDone
                                              ? "Solicitação registrada"
                                              : "Solicitar revisão da oferta"
                                          ) +
                                          " "
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    _vm._l(_vm.result.suggestions, function (suggestion) {
                      return _c(
                        "div",
                        {
                          key: suggestion.ambience_id,
                          staticClass: "suggestion-card mb-2",
                          class: {
                            "recommended-card":
                              suggestion.recommended_rank === 1,
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-center" },
                            [
                              _c("div", { staticClass: "flex-grow-1" }, [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-center" },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-1",
                                        attrs: { small: "" },
                                      },
                                      [_vm._v("mdi-door")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "subtitle-2 font-weight-medium",
                                      },
                                      [_vm._v(_vm._s(suggestion.name))]
                                    ),
                                    suggestion.recommended_rank === 1
                                      ? _c(
                                          "v-chip",
                                          {
                                            staticClass: "ml-2",
                                            attrs: {
                                              "x-small": "",
                                              color: "success",
                                              dark: "",
                                            },
                                          },
                                          [_vm._v(" Recomendada ")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-caption grey--text mt-1",
                                  },
                                  [
                                    _vm._v(
                                      " Capacidade ativa: " +
                                        _vm._s(suggestion.active_capacity) +
                                        " · Vagas livres após troca: " +
                                        _vm._s(suggestion.spare_seats) +
                                        " "
                                    ),
                                    suggestion.same_block
                                      ? _c("span", [_vm._v(" · Mesmo bloco")])
                                      : _vm._e(),
                                    suggestion.same_floor
                                      ? _c("span", [_vm._v(" · Mesmo andar")])
                                      : _vm._e(),
                                  ]
                                ),
                              ]),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    small: "",
                                    color: "primary",
                                    loading: _vm.applying,
                                    disabled: _vm.applying,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.select(suggestion)
                                    },
                                  },
                                },
                                [_vm._v(" Substituir ")]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    0
                  ),
              _c("v-divider", { staticClass: "my-3" }),
              _c(
                "div",
                { staticClass: "d-flex grey--text text-caption flex-wrap" },
                [
                  _c("div", { staticClass: "mr-4" }, [
                    _vm._v(" Encontradas: "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.result.suggestions.length)),
                    ]),
                  ]),
                  _vm.result.match_status
                    ? _c("div", { staticClass: "mr-4" }, [
                        _vm._v(" Status: "),
                        _c("strong", [_vm._v(_vm._s(_vm.statusLabel))]),
                      ])
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c("v-btn", { attrs: { text: "" }, on: { click: _vm.cancel } }, [
                _vm._v("Fechar"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }